export const BASE_URL = "https://api.fineezy.nl/api/v1";
export const ONBOARDING_SKIP_CHECK = false;
export const AUTO_LOGOUT_SECONDS = 60 * 15;
export const LOGOUT_WARNING_SECONDS = 60 * 10;
export const SENTRY_AUTH_TOKEN =
  "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";
